import { useCallback, useRef, useState } from 'react';

export function useMessageBubble({ text, onEditAndAsk, onResend }) {
	const [overlayRect, setOverlayRect] = useState(null);
	const bubbleRef = useRef(null);

	const openOverlay = useCallback((rect) => setOverlayRect(rect), []);

	const closeOverlay = useCallback(() => setOverlayRect(null), []);

	const handleCopy = () => navigator.clipboard?.writeText(text);

	const handleEditAndAsk = () => onEditAndAsk?.(text);

	const handleResend = () => onResend?.(text);

	const handleContextMenu = (e) => {
		e.preventDefault();

		if (!overlayRect) openOverlay(e.currentTarget.getBoundingClientRect());
	};

	return {
		overlayRect,
		bubbleRef,
		closeOverlay,
		handleContextMenu,
		handleCopy,
		handleEditAndAsk,
		handleResend,
	};
}
